module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1bb0adb555e07593962e9fc28ec7566d.svg";